import { IOccupationalStatusProps } from '@my-pages/features/employment/types';
import OccupationStatus from '@my-pages/features/employment/components/Occupation/OccupationStatus.tsx';

const CurrentOccupation = ({ occupationStatus }: IOccupationalStatusProps) => {
    return (
        <div className='card border border-success border-2 h-100'>
            <div className='card-body'>
                <div className='kicker mb-2'>Nuvarande status</div>
                <OccupationStatus occupationStatus={occupationStatus} />
            </div>
        </div>
    );
};

export default CurrentOccupation;
